export const MAX_WORK_ITEM_FILES = 10;
export const MAX_WORK_ITEM_FILE_BYTES = 25000000;
